import {createReducer, on} from '@ngrx/store';
import {ITableColumn} from '../../../../../shared/shared/table/table-column';
import {ITableDataItem} from '../../../../../shared/shared/table/table-data-item';
import {
    IImportedSummaryData, IUnimportedSummaryData
} from '../../../../contract-control/modals/bulk-upload-modal/steps/import-summary-step/import-summary-step.component';
import {
    ICardColumn, IMatchRowItem, IUploadMapping
} from '../../../../contract-control/modals/bulk-upload-modal/steps/match-columns-step/match-columns-step.component';
import {
    IImportPDFMapping
} from '../../../../contract-control/modals/bulk-upload-modal/steps/match-contract-cards-step/match-contract-cards-step.component';
import {
    IFirstLineTitlesResponseDTO, IGetPotentialMappingResponseDTO, IToDoSetImportSettingsRequest
} from '../../../../contract-control/modals/bulk-upload-modal/upload-files.service';
import {HttpActionState} from '../../../../users/userslisting/store/users-listing.reducers';
import * as BulkUploadActions from './documents-bulk-upload.actions';

export interface IDocumentsBulkUploadState {
    uploadId?: number,
    currentStep: DocumentBulkUploadStepEnum,
    firstLineTitles: 0 | 1,
    previewData: ITableDataItem[],
    previewColumns: ITableColumn[],
    merge_organisations: boolean,
    importedSummary: IImportedSummaryData[],
    unimported: IUnimportedSummaryData[],
    failedImports: IImportPDFMapping[],
    firstRow:  IMatchRowItem[],
    cardColumns: ICardColumn[],
    mapping: IUploadMapping[],
    uploadedFiles:File[],
    importSettings?: IToDoSetImportSettingsRequest

    isUpdateMappingRequestInProgress: HttpActionState,
    isSkipStepLoading: HttpActionState,
    isFirstLineLoading: HttpActionState,
    isPotentialMappingLoading: HttpActionState,
    isFetchPDFPreviewRequestInProgress: HttpActionState,
    isImportPDFRequestInProgress: HttpActionState

}

export enum DocumentBulkUploadStepEnum {
    uploadCSV,
    mapColumn,
    preview,
    uploadPDF,
    matchFiles,
    summary
}

const initialState: IDocumentsBulkUploadState = {
    uploadId: null,
    currentStep: DocumentBulkUploadStepEnum.uploadCSV,
    firstLineTitles: 1,
    previewData: [],
    previewColumns: [],
    merge_organisations: true,
    importedSummary: [],
    unimported: [],
    failedImports: [],
    firstRow: [],
    cardColumns:[],
    mapping:[],
    uploadedFiles:[],
    importSettings:null,

    isFirstLineLoading: HttpActionState.Init,
    isPotentialMappingLoading: HttpActionState.Init,
    isSkipStepLoading: HttpActionState.Init,
    isUpdateMappingRequestInProgress: HttpActionState.Init,
    isFetchPDFPreviewRequestInProgress: HttpActionState.Init,
    isImportPDFRequestInProgress: HttpActionState.Init
}


export const documentsBulkUploadReducer = createReducer(initialState,
    on(BulkUploadActions.resetState, () => ({
        ...initialState
    })),
    on(BulkUploadActions.changeStepResult, (state, result) => ({
        ...state,
        currentStep: result.step
    })),
    on(BulkUploadActions.updateFirstLineTitles, (state, result) => ({
        ...state,
        firstLineTitles: result.firstLineTitles
    })),
    on(BulkUploadActions.skipCSVImportClicked, (state)=>({
        ...state,
        isSkipStepLoading:HttpActionState.Busy
    })),

    on(BulkUploadActions.mergeOrganisationsChanged, (state, result) => ({
        ...state,
        mergeOrganisations: result.mergeOrganisations
    })),
    on(BulkUploadActions.fetchPreviewPDFImportSucceed, (state, preview) => ({
        ...state,
        currentStep: DocumentBulkUploadStepEnum.uploadPDF,
        uploadPDFPreview: preview.preview,
        isSkipStepLoading: HttpActionState.Done
    })),
    on(BulkUploadActions.fetchPreviewPDFImportFailed, (state)=>({
        ...state,
        isSkipStepLoading: HttpActionState.Failed
    })),
    on(BulkUploadActions.updateUploadId, (state, {id})=>({
        ...state,
        uploadId: id
    })),

    on(BulkUploadActions.fetchFirstRow, (state) => ({
        ...state,
        isFirstLineLoading: HttpActionState.Busy
    })),
    on(BulkUploadActions.fetchFirstRowSucceed, (state, result) => ({
        ...state,
        isFirstLineLoading: HttpActionState.Done,
        firstRow: mapFirstRowData(result.firstLine, state.firstRow)
    })),
    on(BulkUploadActions.fetchFirstRowFailed, (state) => ({
        ...state,
        isFirstLineLoading: HttpActionState.Failed
    })),

    on(BulkUploadActions.fetchPotentialMappings, (state) => ({
        ...state,
        isPotentialMappingLoading: HttpActionState.Busy
    })),
    on(BulkUploadActions.fetchPotentialMappingsSucceed, (state, result) => ({
        ...state,
        isPotentialMappingLoading: HttpActionState.Done,
        cardColumns: mapCardColumns(result.mapping)
    })),
    on(BulkUploadActions.fetchPotentialMappingsFailed, (state) => ({
        ...state,
        isPotentialMappingLoading: HttpActionState.Failed
    })),
    on(BulkUploadActions.mappingChanged, (state, {mapping}) => ({
        ...state,
        mapping: mapping
    })),
    on(BulkUploadActions.saveMappings, (state) => ({
        ...state,
        isUpdateMappingRequestInProgress: HttpActionState.Busy
    })),
    on(BulkUploadActions.saveMappingsSucceed, (state) => ({
        ...state,
        isUpdateMappingRequestInProgress: HttpActionState.Done,

    })),
    on(BulkUploadActions.saveMappingsFailed, (state) => ({
        ...state,
        isUpdateMappingRequestInProgress: HttpActionState.Failed
    })),
    on(BulkUploadActions.resetIsUpdateMappingRequestInProgress, (state) => ({
        ...state,
        isUpdateMappingRequestInProgress: initialState.isUpdateMappingRequestInProgress
    })),

     on(BulkUploadActions.importPDF, (state) => ({
        ...state,
        isImportPDFRequestInProgress: HttpActionState.Busy
    })),
    on(BulkUploadActions.importPDFFailed, (state) => ({
        ...state,
        isImportPDFRequestInProgress: HttpActionState.Failed
    })),
    on(BulkUploadActions.setImportSettings, (state, {importSettings})=>({
        ...state,
        importSettings:importSettings
    }))
);


function mapFirstRowData (firstRow:IFirstLineTitlesResponseDTO, orginal: IMatchRowItem[] = []){
    const newData: IMatchRowItem[] = [];

    for (let i=0; i< firstRow?.data_row?.length; i++){
        if(orginal[i] != undefined){
            newData.push(orginal[i]);
            
        }else{
            newData.push({
                title: firstRow?.title_row ? firstRow?.title_row[i]: '',
                value: firstRow?.data_row ? firstRow?.data_row[i]: ''
            });
        }
    }
    return [...newData];
}

function mapCardColumns(mapping: IGetPotentialMappingResponseDTO) {
    if(mapping){
        return  Object.values(mapping).map(item => ({
            label: item.label,
            dataFieldContact: item.type,
            column: item.column,
            is_required: item.is_required,
            ...matchIconByType(item.type)
        }))
    }
    return []
 
}

function matchIconByType(type: string): Partial<ICardColumn> {
    switch (type) {
    case 'cost':
        return {
            icon: 'dollar-sign'
        }
    case 'period': {
            return {
                icon: 'trending-up'
            }
        }
    case 'custom_field':{
            return {
                icon:'package'
            }
        }
    case 'revenue': {
            return {
                icon:'trending-up'
            }
        }
    case 'general': {
            return {
                bootstrapIcon:"fa fa-building-o m-0"
            }
        }
    }

    return {
        icon: 'package'
    }
}
